import { BaseChart } from "./BaseChart";
import { TimePeriod } from "./TimePeriodSelector";
import type { WeightResponse } from "@/types/tracker";
import { processSimpleTrackerChartData } from "./utils";
import { getMetricColor } from "./chart-theme";

interface WeightChartProps {
  data: WeightResponse | null;
  selectedPeriod: TimePeriod;
  currentDate: Date;
  onDeleteReading?: (readingId: string) => void;
}

export const WeightChart = ({
  data,
  selectedPeriod,
  currentDate,
}: WeightChartProps) => {
  const hasData = data && data.data && data.data.length > 0;
  const yAxisConfig = data?.y_axis || { min: 50, max: 100 };
  const chartData = processSimpleTrackerChartData(
    data,
    selectedPeriod,
    currentDate
  );

  return (
    <BaseChart
      data={chartData}
      selectedPeriod={selectedPeriod}
      currentDate={currentDate}
      yAxisConfig={yAxisConfig}
      chartColor={getMetricColor("weight")}
      metricName="Weight"
      unit="kg"
    />
  );
};
